<div class="settings-container">
  <h2>Manage Default Columns for Entity</h2>
  <label>Select Entity:
    <select [(ngModel)]="selectedEntity" (change)="changeEntity(selectedEntity)">
      <option *ngFor="let entity of entities" [value]="entity">{{ entity }}</option>
    </select>
  </label>

  <div class="settings-grid-wrapper">
    <table class="column-settings-table">
      <thead>
        <tr>
          <th></th>
          <th>Field</th>
          <th>Header Name</th>
          <th>Visible</th>
          <th>Pinned</th>
          <th>Width</th>
          <th>Sort</th>
          <th>Sort Index</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let col of columnConfig; let i = index; trackBy: trackByField"
            draggable="true"
            (dragstart)="onDragStart(i)"
            (dragover)="$event.preventDefault()"
            (drop)="onDrop(i)"
            class="settings-row">
          <td class="drag-handle">☰</td>
          <td>{{ col.field }}</td>
          <td><input [ngModel]="col.headerName" (ngModelChange)="updateField(i, 'headerName', $event)"/></td>
          <td><input type="checkbox" [(ngModel)]="col.visible" (ngModelChange)="updateField(i, 'visible', $event)"/></td>
          <td>
            <select [(ngModel)]="col.pinned" (ngModelChange)="updateField(i, 'pinned', $event)">
              <option [ngValue]="undefined">None</option>
              <option value="left">Left</option>
              <option value="right">Right</option>
            </select>
          </td>
          <td><input type="number" [ngModel]="col.width" (ngModelChange)="updateField(i, 'width', $event)" style="width: 60px;"/></td>
          <td>
            <select [(ngModel)]="col.defaultSort" (ngModelChange)="updateField(i, 'defaultSort', $event)">
              <option [ngValue]="undefined">—</option>
              <option value="asc">Asc</option>
              <option value="desc">Desc</option>
            </select>
          </td>
          <td><input type="number" [ngModel]="col.sortIndex" (ngModelChange)="updateField(i, 'sortIndex', $event)" style="width: 50px;"/></td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="settings-actions">
    <button (click)="saveConfig()" [disabled]="isSaving">
      <span *ngIf="!isSaving">💾 Save</span>
      <span *ngIf="isSaving">⏳ Saving...</span>
    </button>
    <button (click)="resetConfig()">Reset to Default</button>
  </div>
</div>
